import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SmsConfirmDialogData {
  title: string;
  message: string;
  /** Optional secondary line under the message (e.g. record name). */
  details?: string;
  /** Optional collapsible list for reviewing many affected records. */
  items?: { label: string; detail?: string }[];
  itemsLabel?: string;
  /** Apply the destructive accent (red strip + red confirm button). */
  danger?: boolean;
  /** Confirm button label. Default: "Confirm". */
  confirmText?: string;
  /** Cancel button label. Default: "Cancel". */
  cancelText?: string;
}

/**
 * Single confirm dialog used for delete / discard / unsaved-changes flows.
 * Replaces the 12+ duplicated confirm-* dialogs in the repo.
 *
 * Open via DialogService.confirm() — do not open directly from features.
 */
@Component({
  selector: 'app-sms-confirm-dialog',
  templateUrl: './sms-confirm-dialog.component.html',
  styleUrls: ['./sms-confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SmsConfirmDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SmsConfirmDialogData,
    public dialogRef: MatDialogRef<SmsConfirmDialogComponent, boolean>
  ) {
    this.data = {
      confirmText: 'Confirm',
      cancelText: 'Cancel',
      danger: false,
      ...data
    };
  }

  onConfirm(): void { this.dialogRef.close(true); }
  onCancel(): void  { this.dialogRef.close(false); }
}
